import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "max-bid-row" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "bid-row" }
const _hoisted_4 = { class: "bid-field-container" }
const _hoisted_5 = { class: "button-column" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "follow-container" }
const _hoisted_8 = {
  key: 0,
  class: "error-row"
}
const _hoisted_9 = {
  key: 0,
  class: "max-bid-message"
}
const _hoisted_10 = {
  key: 0,
  class: "losing-bid-message"
}
const _hoisted_11 = {
  key: 0,
  class: "bid-suggestion-row"
}
const _hoisted_12 = { class: "bid-suggestion-list" }
const _hoisted_13 = ["disabled", "onClick", "aria-pressed"]

import { type PropType, computed, nextTick, ref, watch } from "vue";
import CoolCheckbox2 from "../../shared/CoolCheckbox2.vue";
import CoolInput from "../../shared/CoolInput.vue";
import CoolButton from "../../shared/CoolButton.vue";
import FollowButton from "../../frontend-productlist/product-list/list-item-component/common/follow-button.vue";
import CardManagementMain from "../../profile/card-management/bid-options/bid-options-main.vue";
import { type PhoneValidation, type AuctionProduct, type Setup } from "./types";
import {
    createCurrencyFormatter,
    getCurrencySymbol,
} from "../common/amount-format";
import axios from "axios";
import FadeAndSlide from "../../shared/FadeAndSlide.vue";
import PhoneValidationComp from "../bidding/phone-validation/phone-validation.vue";

import { loginPopup } from "../../../../legacy/loginPopup";
import labels from "../../shared/labels";
import OfflineWarning from "../product-specs/OfflineWarning.vue";
import { checkLoggedIn } from "./login";
import { format } from "../../../../shared/utils/string";
import { odendoTrackingService } from "../../../../tracking/tracking";
import CurrencyFormattedInput from "./currency-formatted-input.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bid-form',
  props: {
    product: {
        type: Object as PropType<AuctionProduct>,
        required: true,
    },
    setup: {
        type: Object as PropType<Setup>,
        required: true,
    },
    phoneValidation: Object as PropType<PhoneValidation>,
},
  setup(__props) {

const formatter = createCurrencyFormatter();
const currencySymbols = getCurrencySymbol(formatter);
const props = __props;

const suggestionAmounts = ref<number[]>();
const maxBid = ref(true);
const errors = ref<string[]>([]);
const blitzBidField = ref(false);
const bidAmount = ref<number>();
const savedCardStatus = ref<"missing" | "ok">();
const validationPhone = ref<string>();
const smsValidationId = ref<string>();
const isLoggedIn = window.isAuthenticated() === true;
const loading = ref(false);
const openForBid = computed(
    () =>
        props.product.timeIsNotStarted === false &&
        props.product.timeTotalSeconds > 0
);
const disabled = computed(() => loading.value || !openForBid.value);

function formatAmounts(value: number) {
    return formatter.format(value);
}

function blitzField() {
    blitzBidField.value = true;
    requestAnimationFrame(() => {
        setTimeout(() => (blitzBidField.value = false), 100);
    });
}

function setAmount(v: number) {
    bidAmount.value = v;
    blitzField();
}

function disableDecimalKeys(e: Event) {
    if (!(e instanceof KeyboardEvent)) {
        return;
    }
    if (
        //["Comma","Period", "Slash", "NumpadAdd","NumpadSubtract", "Minus", "KeyE"].includes(e.code)
        [",", ".", "+", "e"].includes(e.key)
    ) {
        e.preventDefault();
    }
}

const savedCardForm = ref<InstanceType<typeof CardManagementMain>>();

async function submitBid() {
    if (loading.value) return;
    loading.value = true;
    try {
        errors.value = [];
        const value = bidAmount.value;
        if (typeof value !== "number" || isNaN(value)) return;

        if (props.setup.enableMissingPaymentStrike) {
            if (savedCardStatus.value != "ok") {
                if (savedCardForm.value != null) {
                    (
                        savedCardForm.value as unknown as {
                            openPopup: (callback: () => void) => void;
                        }
                    ).openPopup(function () {
                        nextTick(() => submitBid());
                    });
                }
                return;
            }
        }

        const estimate = props.product.estimatedPrice;
        if (typeof estimate == "number" && estimate > 0 && value >= estimate) {
            const confirmLabel =
                labels.frontendProductpage.auction
                    .bidAboveEstimatedValueConfirmation;
            if (
                typeof confirmLabel === "string" &&
                confirmLabel.length > 0 &&
                !confirm(
                    labels.frontendProductpage.auction
                        .bidAboveEstimatedValueConfirmation
                )
            ) {
                return;
            }
        }
        const response = await axios.post<{
            success: boolean;
            noLogin?: true | undefined | null;
            message?: string | undefined | null;
        }>("/auctionProduct/BidJson", {
            productId: props.product.id,
            urlRef: btoa(location.href),
            maxBid: maxBid.value,
            savedCardStatus: savedCardStatus.value,
            amount: bidAmount.value,
            validationPhone: validationPhone.value,
            smsValidationId: smsValidationId.value,
            reuseSmsValidationId: props.phoneValidation?.reuseSmsValidationId,
        });

        const data = response.data;
        if (data.success !== true) {
            if (data.noLogin === true) {
                loginPopup();
                return;
            }
            if (data.message != null) {
                console.error(data.message);
                errors.value = [data.message];
            } else {
                errors.value = ["Unknown error"];
            }
        } else {
            odendoTrackingService.trackBid();
        }
    } finally {
        loading.value = false;
    }
}

watch(
    () => props.product.currentBid,
    async (newAmount) => {
        const response = await axios.get<number[]>("/ajax/GetBidSuggestions", {
            params: {
                amount: newAmount,
            },
        });
        suggestionAmounts.value = response.data;
        if (bidAmount.value == null) {
            bidAmount.value =
                (props.product.currentBid ?? 0) + suggestionAmounts.value[0];
        }
    },
    {
        immediate: true,
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createVNode(OfflineWarning, { class: "offline-warning" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CoolCheckbox2, null, {
        label: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(labels).frontendProductpage.auction.maxBid), 1 /* TEXT */)
        ]),
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "data-ignorereplace": "true",
            disabled: disabled.value,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_unref(checkLoggedIn)($event))),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(checkLoggedIn)($event))),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((maxBid).value = $event))
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
            [_vModelCheckbox, maxBid.value]
          ])
        ], undefined, true),
        _: 1 /* STABLE */
      })
    ]),
    (isLoggedIn && __props.setup.enableMissingPaymentStrike)
      ? (_openBlock(), _createBlock(CardManagementMain, {
          key: 0,
          "terms-link": __props.setup.termsUrl,
          "onUpdate:savedCardStatus": _cache[3] || (_cache[3] = ($event: any) => (savedCardStatus.value = $event)),
          "no-spinner": "",
          ref_key: "savedCardForm",
          ref: savedCardForm
        }, null, 8 /* PROPS */, ["terms-link"]))
      : _createCommentVNode("v-if", true),
    (isLoggedIn && __props.phoneValidation != null)
      ? (_openBlock(), _createBlock(PhoneValidationComp, {
          key: 1,
          class: "phone-validation-comp",
          "product-id": __props.product.id,
          "sms-validation": __props.phoneValidation.smsValidation,
          "sms-already-valid": __props.phoneValidation.smsAlreadyValid,
          "reuse-sms-validation-id": 
                    __props.phoneValidation.reuseSmsValidationId ?? undefined
                ,
          "onUpdate:smsValidationId": _cache[4] || (_cache[4] = ($event: any) => (smsValidationId.value = $event)),
          "onUpdate:validationPhone": _cache[5] || (_cache[5] = ($event: any) => (validationPhone.value = $event)),
          "existing-validation-id": 
                    __props.phoneValidation.existingValidationId ?? undefined
                ,
          "existing-validation-phone": 
                    __props.phoneValidation.existingValidationPhone ?? undefined
                
        }, null, 8 /* PROPS */, ["product-id", "sms-validation", "sms-already-valid", "reuse-sms-validation-id", "existing-validation-id", "existing-validation-phone"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(currencySymbols)[0]) + " ", 1 /* TEXT */),
        _createVNode(CoolInput, { "number-arrows": false }, {
          default: _withCtx(() => [
            _createVNode(CurrencyFormattedInput, {
              onFocus: _cache[6] || (_cache[6] = ($event: any) => (_unref(checkLoggedIn)($event))),
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => (_unref(checkLoggedIn)($event))),
                _cache[8] || (_cache[8] = ($event: any) => ((bidAmount).value = $event))
              ],
              modelValue: bidAmount.value,
              disabled: disabled.value,
              min: (__props.product.currentBid ?? 0) + 1,
              step: 1,
              onKeypress: _cache[9] || (_cache[9] = ($event: any) => (disableDecimalKeys($event))),
              class: _normalizeClass({ 'bid-field': true, blitz: blitzBidField.value })
            }, null, 8 /* PROPS */, ["modelValue", "disabled", "min", "class"])
          ], undefined, true),
          _: 1 /* STABLE */
        }),
        _createTextVNode(" " + _toDisplayString(_unref(currencySymbols)[1]), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CoolButton, {
          theme: "turqoise",
          size: "large",
          "full-width": "",
          busy: loading.value,
          "busy-size": 32
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "submit-bid",
              disabled: disabled.value,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(checkLoggedIn)($event) && submitBid()))
            }, _toDisplayString(_unref(labels).frontendProductpage.auction.bidButton), 9 /* TEXT, PROPS */, _hoisted_6)
          ], undefined, true),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["busy"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(FollowButton, {
          class: "follow-comp",
          "product-id": __props.product.id
        }, null, 8 /* PROPS */, ["product-id"])
      ])
    ]),
    _createVNode(FadeAndSlide, null, {
      default: _withCtx(() => [
        (errors.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
                return (_openBlock(), _createElementBlock("div", null, _toDisplayString(error), 1 /* TEXT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    _createVNode(FadeAndSlide, null, {
      default: _withCtx(() => [
        (
                    __props.product.winningBid != null &&
                    __props.product.winningBid.currentUser &&
                    __props.product.winningBid.maxBid != null &&
                    __props.product.winningBid.maxBid > 0
                )
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(format)(
                        _unref(labels).frontendProductpage.auction.currentMaxBid,
                        formatAmounts(__props.product.winningBid.maxBid)
                    )), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    _createVNode(FadeAndSlide, null, {
      default: _withCtx(() => [
        (
                    __props.product.hasBidOnProduct &&
                    __props.product.winningBid != null &&
                    !__props.product.winningBid.currentUser
                )
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(labels).frontendProductpage.auction.losingBidMessage), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    _createVNode(FadeAndSlide, null, {
      default: _withCtx(() => [
        (suggestionAmounts.value == null || suggestionAmounts.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("ul", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestionAmounts.value ?? [
                            -1, -2, -3,
                        ], (suggestionAmount) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: suggestionAmount,
                    class: "bid-suggestion-item"
                  }, [
                    _createElementVNode("button", {
                      class: "bid-suggestion-button",
                      type: "button",
                      disabled: suggestionAmount <= 0,
                      onClick: ($event: any) => (
                                _unref(checkLoggedIn)($event) &&
                                    setAmount(
                                        (__props.product.currentBid ?? 0) +
                                            suggestionAmount
                                    )
                            ),
                      "aria-pressed": 
                                bidAmount.value ==
                                (__props.product.currentBid ?? 0) + suggestionAmount
                                    ? 'true'
                                    : 'false'
                            
                    }, [
                      (suggestionAmount > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" +" + _toDisplayString(formatAmounts(suggestionAmount)), 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("   ")
                          ], 64 /* STABLE_FRAGMENT */))
                    ], 8 /* PROPS */, _hoisted_13)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    })
  ], 32 /* NEED_HYDRATION */))
}
}

})